import { render, staticRenderFns } from "./DynamicComponentRenderer.vue?vue&type=template&id=2afce6b8&scoped=true&"
import script from "./DynamicComponentRenderer.vue?vue&type=script&lang=js&"
export * from "./DynamicComponentRenderer.vue?vue&type=script&lang=js&"
import style0 from "./DynamicComponentRenderer.vue?vue&type=style&index=0&id=2afce6b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afce6b8",
  null
  
)

export default component.exports